import React, { FC } from 'react'

import { IconSadTobiProps } from './IconSadTobi.types'
import * as Styled from './styles/IconSadTobi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSadTobi: FC<IconSadTobiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSadTobiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSadTobiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 55 55' xmlns='http://www.w3.org/2000/svg'>
        <defs />
        <g fill='none' transform='translate(4 3)'>
          <path
            d='M39.477 20.339h-.165a5.796 5.796 0 0 1-.398.281 15.41 15.41 0 0 1-3.543 1.69c-1.501.492-3.05.868-4.645 1.126a43.686 43.686 0 0 1-13.983 0c-3.707-.634-6.757-1.736-8.563-3.12a2.548 2.548 0 0 0-2.042.96 4.14 4.14 0 0 0-.797 1.76v6.241c0 .329.024.658.047.963.821 10.135 9.689 17.665 19.824 16.868 8.986-.728 16.118-7.86 16.869-16.868.023-.329.047-.634.047-.963v-6.216c-.164-.635-.423-1.244-.798-1.76a2.582 2.582 0 0 0-1.853-.962z'
            fill='#EBEBEB'
          />
          <path
            d='M.93 29.3a5.508 5.508 0 0 1-.328-1.853v1.854a5.867 5.867 0 0 0 5.865 5.865 15.608 15.608 0 0 1-.68-2.322A5.376 5.376 0 0 1 .93 29.3m45.494 0c-.742 2.042-2.62 3.45-4.777 3.544a17.503 17.503 0 0 1-.673 2.322c3.2 0 5.798-2.627 5.798-5.865v-1.854c0 .634-.115 1.267-.348 1.854'
            fill='#900'
          />
          <path
            d='M.602 22.756c0 .14-.024.257-.024.398v4.317a5.406 5.406 0 0 0 5.161 5.396 19.017 19.017 0 0 1-.398-2.58 11.693 11.693 0 0 1-.047-.963c-.016-.328-.016-.5 0-.515v-5.725c.14-.634.399-1.244.798-1.76a2.477 2.477 0 0 1 2.04-.962c1.807 1.361 4.857 2.487 8.564 3.12a43.614 43.614 0 0 0 13.983 0 30.857 30.857 0 0 0 4.622-1.126 15.364 15.364 0 0 0 3.542-1.689c.141-.093.282-.187.399-.281h.165a2.47 2.47 0 0 1 1.876.962c.4.516.68 1.126.798 1.76v6.24c0 .329-.023.657-.047.961a19.13 19.13 0 0 1-.398 2.581 5.448 5.448 0 0 0 4.809-3.519c.21-.586.328-1.22.328-1.83v-2.557c.047-.47.047-.962.047-1.502C46.89 10.626 36.52.256 23.734.256c-12.528 0-22.78 9.97-23.132 22.5z'
            fill='#E60000'
          />
          <path
            d='M28.45 14.849a4.748 4.748 0 0 1-1.384 1.666 5.168 5.168 0 0 1-4.645.891 5.513 5.513 0 0 1-3.074-2.3 6.166 6.166 0 0 1-.704-1.547c0-.048-.023-.07-.023-.118a4.367 4.367 0 0 1-.164-.938 6.91 6.91 0 0 1-.024-.986v-.093a6.85 6.85 0 0 1 .211-1.384c.423-1.69 1.385-3.191 2.698-4.317a9.219 9.219 0 0 1 2.628-1.549c.258-.094.54-.187.798-.258l.493-.14a9.92 9.92 0 0 1 1.22-.212 5.251 5.251 0 0 1 1.22 0c.07 0 .14.023.187.047-1.807.399-3.12 1.994-3.12 3.848v.117c.727.14 1.407.399 2.04.774.517.329.986.727 1.338 1.22l.07.118c.259.375.446.797.587 1.243.14.446.211.915.235 1.384v.188a5.503 5.503 0 0 1-.587 2.346m-4.715-12.2c-5.326 0-9.62 4.317-9.62 9.619 0 5.303 4.317 9.62 9.62 9.62 5.302 0 9.619-4.317 9.619-9.62 0-5.325-4.317-9.62-9.62-9.62'
            fill='#FFF'
          />
          <path
            d='M15.11 41.478a.766.766 0 0 0 1.066 0c4.08-3.976 10.686-3.976 14.766 0a.767.767 0 0 0 1.065-.005.723.723 0 0 0 .01-1.025l-.044-.043c-4.674-4.533-12.22-4.523-16.882.024a.724.724 0 0 0 .01 1.04l.01.01m-1.746-11.845a2.905 2.905 0 0 0 3.518 2.086 2.914 2.914 0 0 0 2.083-2.086c.383-1.558-.55-3.14-2.083-3.524-1.555-.383-3.135.552-3.518 2.085-.048.24-.096.48-.096.72v.048c0 .24.048.456.096.671m15.06.022c.406 1.543 1.983 2.445 3.513 2.065a2.897 2.897 0 0 0 2.078-2.065c.048-.166.072-.332.072-.523v-.19a2.876 2.876 0 0 0-2.844-2.918c-1.6-.024-2.915 1.233-2.939 2.824 0 .284.024.546.12.807'
            fill='#4A4D4E'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSadTobi
